import { render, staticRenderFns } from "./TakeALookBanner.vue?vue&type=template&id=772a226f"
import script from "./TakeALookBanner.vue?vue&type=script&lang=js"
export * from "./TakeALookBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports